import { SETISLOADINGINUSERS, SETUSERS } from '../actions/users';
import { SETCLIENTS, SETISLOADINGINCLIENTS } from '../actions/clients';

const initialState = {
  isLoadingUsers: false,
  users: [],
  isLoadingClients: false,
  clients: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SETISLOADINGINUSERS:
      return { ...state, isLoadingUsers: action.isLoadingUsers };
    case SETUSERS:
      return { ...state, users: action.users };
    case SETISLOADINGINCLIENTS:
      return { ...state, isLoadingClients: action.isLoadingClients };
    case SETCLIENTS:
      return { ...state, clients: action.clients };
    default:
      return state;
  }
};
